<script setup lang="ts">
import MemoryUsage from './MemoryUsage.vue';
import FpsCounter from './FpsCounter.vue';
import { ToolbarStorage } from '../../business/ToolbarStorage';
import { useBottomBarSize } from '~/features/bottom-bar';
import { EDebugFeature } from '../../models';

const { bottomBarHeight } = useBottomBarSize();

const isMemoryShown = computed(() => ToolbarStorage.getDebugValue(EDebugFeature.MEMORY));
const isFpsShown = computed(() => ToolbarStorage.getDebugValue(EDebugFeature.FPS));

const isShown = computed(() => isMemoryShown.value || isFpsShown.value);
</script>

<template>
  <div v-if="isShown" class="debug-container" :style="{ bottom: `${bottomBarHeight + 4}px` }">
    <MemoryUsage v-if="isMemoryShown" />
    <FpsCounter v-if="isFpsShown" />
  </div>
</template>

<style scoped lang="stylus">
.debug-container
  position fixed
  right 4px
  z-index 9999
  display flex
  flex-direction column
  gap 4px
  pointer-events none
  user-select none
</style>
